import React from 'react';
import AlertDialog from './AlertDialog';
import { useHistory } from 'react-router';
import { postJSONPS } from '../../lib/utils/fetch';
import { composePS } from '@cd/pipe';
import { either } from '../../lib/utils/utils';

/** postLogout ::  Promise(Either) */
const postLogout = (user, pwd) =>
	composePS(postJSONPS)('POST', `/logout`, {
		body: JSON.stringify({ user, pwd })
	});

const Logout = ({ onLogout, openDlg, title, message }) => {
	const history = useHistory();

	const onOK = () => {
		postLogout().then(
			either(console.log, () => {
				onLogout();
			})
		);
	};

	const onCancel = () => {
		history.push('/dashboard/view');
	};

	return (
		<AlertDialog
			openDlg={false}
			title={title}
			message={message}
			buttonText={['OK', 'CANCEL']}
			onOK={onOK}
			onCancel={onCancel}
		/>
	);
};

export default Logout;
